<template>
  <v-container fluid>
    <v-row>
      <v-col
        sm="6"
        lg="7"
        xl="8"
      >
        <GmapMap
          ref="sharerMap"
          :center="centerMap"
          :zoom="zoomMap"
          map-type-id="satellite"
          class="status-map"
          :options="{
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: true,
          }"
          @click="isInfoShown = false"
        >
          <GmapMarker
            v-for="(m, index) in playerList"
            :key="index"
            :position="m.position"
            :clickable="true"
            :draggable="false"
            :icon="require('../assets/icon/check.png')"
            :title="m.name"
            @click="m.isInfoShown = clickPreview(m)"
          />
        </GmapMap>
      </v-col>
      <v-col
        sm="6"
        lg="5"
        xl="4"
      >
        <players-container @itemSelected="selectMarker" />
      </v-col>
    </v-row>
    <dialog-preview-schedule
      ref="previewSchedule"
      :no-btn="true"
      :players-selected="playersSelected"
      :open-dialog="openPreview"
    />
  </v-container>
</template>

<script>
// Components
import dialogPreviewSchedule from "./Dialog/DialogPreviewSchedule";
import playersContainer from "./ViewerPage/PlayersContainer";

// Connectors
import { PlayerConnector } from "./Database/PlayerConnector";

export default {
  components: {
    playersContainer,
    dialogPreviewSchedule,
  },
  data() {
    return {
      playerConnector: new PlayerConnector(this.$store.state.user),
      appPages: true,
      bounds: null,
      centerMap: { lat: 47.0, lng: 2.0 },
      openPreview: false,
      playersSelected: [],
      playerList: [],
      zoomMap: 6,
    };
  },
  created() {
    document.title = this.$t("navbar.viewer") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.viewer"));
  },
  mounted() {
    // API CALLS
    this.getAllPlayers()
      .then((listPlayer) => {
        this.playerList = listPlayer;

        this.initMaps();
      })
      .catch((err) => {
        console.error(err);
      });
  },
  methods: {
    autoZoom() {
      if (this.bounds) {
        this.$refs.sharerMap.fitBounds(this.bounds);
      }
    },
    changePage() {
      this.$router.push({ path: "/status" });
    },
    clickPreview(marker) {
      if (marker !== undefined) {
        const currentPlayer = {
          id: 1,
          name: marker.name,
          plyrID: marker.id,
        };

        this.showPreview(currentPlayer);
      }
    },
    getAllPlayers() {
      return new Promise((resolve, reject) => {
        this.playerConnector
          .getAllPlayers()
          .then((players) => {
            // TODO: format in db server
            const listPlayers = players.map((element) => {
              return {
                id: element.id_plyr,
                name: element.name,
                position: {
                  lat: parseFloat(element.lat),
                  lng: parseFloat(element.lng),
                },
                isInfoShown: false,
                lastUpdate: element.last_update,
                lastConnection: element.last_connect,
                problems: [
                  {
                    name: "connected",
                    icon: "map-marker-check",
                  },
                ],
              };
            });

            return resolve(listPlayers);
          })
          .catch((err) => {
            return reject(err);
          });
      });
    },
    initMaps() {
      this.$gmapApiPromiseLazy().then(() => {
        // eslint-disable-next-line no-undef
        this.bounds = new google.maps.LatLngBounds();
        const boundTemp = [];

        for (let i = 0; i < this.playerList.length; i++) {
          boundTemp.push({
            lat: parseFloat(this.playerList[i].position.lat),
            lng: parseFloat(this.playerList[i].position.lng),
          });

          if (boundTemp[i] != null) {
            this.bounds.extend(boundTemp[i]);
          }
        }

        this.$refs.sharerMap.panToBounds(this.bounds);
        this.autoZoom();
      });
    },
    selectMarker(item) {
      if (item.length > 0) {
        if (item[0].plyrID !== undefined) {
          const currentPlayer = {
            id: 1,
            name: item[0].name,
            plyrID: item[0].plyrID,
          };

          this.showPreview(currentPlayer);
        }
      }
    },
    showPreview(player) {
      this.openPreview = false;
      this.playersSelected = [player];
      const _this = this;

      // Need to add delay before opening
      setTimeout(function () {
        _this.$refs.previewSchedule.preview();
        _this.openPreview = true;
      }, 1000);
    },
  },
};
</script>

<style>
.icon {
  color: black;
  font-size: 20px;
  font-weight: bold;
}

.iconTitle:before {
  content: "";
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.2em;
  display: inline-block;
  background-size: cover;
  background-image: url("../assets/icon/tag.png");
}

.iconNetwork:before {
  content: "";
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.2em;
  display: inline-block;
  background-size: cover;
  background-image: url("../assets/icon/check-network.png");
}

.iconUpdate:before {
  content: "";
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.2em;
  display: inline-block;
  background-size: cover;
  background-image: url("../assets/icon/update.png");
}

.status-map {
  width: 100%;
  height: 100%;
}
</style>
